export function calcPLN(amount: number, rate: number): number {
  return parseFloat((amount * rate).toFixed(2))
}

export function formatPLN(value?: number | null): string {
  return (value || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
